import TalentMatrices from "@/modules/talentMatrix/views/TalentMatrices.vue";
import TalentMatrix from "@/modules/talentMatrix/views/TalentMatrix.vue";

export default [
  {
    path: '/talent-matrix/matrices',
    name: 'TalentMatrices',
    component: TalentMatrices,
    meta: {title: 'Матрицы талантов'}
  },
  {
    path: '/talent-matrix/matrix/:id(\\d+)',
    name: 'TalentMatrix',
    component: TalentMatrix,
    meta: {title: 'Матрица талантов'}
  },
]
